module.exports = __webpack_public_path__ + "img/5.5c2d0577.jpg";